<template>
  <v-container fluid>
      <v-form ref="addForm">
        <v-row>
            <v-col cols=12>
                <v-card>
                  <v-toolbar flat color="secondary" dark>
                      <v-icon left>mdi-clipboard-text</v-icon>
                      <v-toolbar-title>Purchase order - Detail</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn text @click="save">Save</v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols=3>
                          <v-text-field v-model="model.poNumber" label="PO Number" hint="Leave empty for autogenerate it"/>
                        </v-col>
                        <v-col cols=3>
                          <supplier v-model="model.supplierId" label="Supplier" :rules="[rules.required]" />
                        </v-col>
                        <v-col cols=3>
                          <date label="Order Date" v-model="model.orderDate" :rules="[rules.required]"  />
                        </v-col>
                        <v-col cols=3>
                          <warehouse v-model="model.shipToWarehouseId" label="Ship to Warehouse" :rules="[rules.required]" />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols=3>
                          <date label="Requested Ship Date" v-model="model.requestedShipDate" />
                        </v-col>
                        <v-col cols=3>
                          <v-select :items="sentStatus" v-model="model.sentStatus" label="Sent Status" />
                        </v-col>
                        <v-col cols=3>
                          <v-text-field v-model="model.trackingInfo" label="Tracking Info"/>
                        </v-col>
                        <v-col cols=3>
                          <date label="Arrival Due Date" v-model="model.arrivalDueDate" />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols=3>
                          <v-select :items="paymentStatus" v-model="model.paymentStatus" label="Payment Status" />
                        </v-col>
                        <v-col cols=3>
                          <date label="Order Cancel Date" v-model="model.orderCancelDate" />
                        </v-col>
                        <v-col cols=3>
                          <v-select v-model="model.currency" :items="currencies" item-text="currency" item-value="currency" label="Currency" :rules="[rules.required]"></v-select>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols=12>
                <v-card>
                  <v-toolbar flat color="secondary" dark>
                      <v-icon left>mdi-format-list-bulleted</v-icon>
                      <v-toolbar-title>PO's Rows</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <add-product :currency="model.currency" @added="addLine($event)" />
                  </v-toolbar>
                  <v-card-text>
                      <v-data-table :items="model.lines" :headers="headers">
                        <template v-slot:item.total="{item}">
                          {{item.quantity*item.unit_cost}} {{model.currency}}
                        </template>
                        <template v-slot:item.actions="{item}">
                          <v-btn icon @click="deleteItem(item)">
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                        </template>
                      </v-data-table>
                  </v-card-text>
                </v-card>
            </v-col>
        </v-row>
      </v-form>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex"
import Date from '../../components/Date.vue';
import Supplier from '../../components/forms/select/Supplier.vue';
import Warehouse from '../../components/forms/select/Warehouse.vue';
import AddProduct from '../../components/purchaseOrder/AddProduct.vue';

export default {
  components: { Date, Supplier, Warehouse, AddProduct },

  data: function() {
    return {
      setCurrency:null,
      currency:null,
      poId: null,
      headers:[
          {text:'Sku', value:'product.sku'},
          {text:'Unit Cost', value:'unit_cost'},
          {text:'Quantity', value:'quantity'},
          {text:'Total', value:'total'},
          {text:'Actions', value:'actions'},
      ],
      model:{
        lines:[]
      },
      rules: {
          required: value => !!value || "This field is mandatory.",
      },
      paymentStatus :[
        {text:'None Paid', value:'nonePaid'},
        {text:'Partially Paid', value:'partiallyPaid'},
        {text:'Fully Paid', value:'fullyPaid'},
      ],
      sentStatus :[
        {text:'Not Sent', value:'notSent'},
        {text:'Sent', value:'sent'},
      ]
    };
  },
  computed:{
    ...mapGetters("currencies",["currencies"])
  },
  mounted: function() {
    this.getCurrencies()
  },
  methods: {
    ...mapActions("purchaseOrders", ["create"]),
    ...mapActions("currencies", {getCurrencies:'index'}),
    save(){
        this.errors=[]
        if (this.$refs.addForm.validate() && this.model.lines.length > 0) {
            this.loading=true
            this.create(this.model)
            .then(({po}) => {
              this.$router.push("/purchase-order/view/"+po.id)
            })
            .catch(({data}) => {
                for (const error of Object.entries(data.errors)) {
                    this.errors.push(error[1][0])
                }
            })
            .finally(() => {
                this.loading=false
            })
        }
    },
    addLine(line){
      if(this.model.lines.find(l => l.productId == line.productId)){
        let idx = this.model.lines.findIndex(l => l.productId == line.productId);
        this.model.lines[idx].quantity += line.quantity;
        this.model.lines[idx].unit_cost = line.unit_cost
      }else{
        this.model.lines.push(line)
      }
    },
    deleteItem(item){
      this.model.lines = this.model.lines.filter(l => l.productId != item.productId)
    }
  }
}
</script>

<style>

</style>